function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.2,9.2c-2.5-2.4-6.4-2.3-8.8,0.3c-0.8,0.8-1.2,1.7-1.5,2.7c0,0.2-0.1,0.3-0.1,0.5c0,0.1,0,0.2,0,0.3 c0,0.2-0.1,0.4-0.1,0.6l0.2,70.2c0.1,1.3,0.6,2.7,1.7,3.8c2.3,2.5,6.2,2.7,8.8,0.3c0,0,37.6-34.9,37.4-34.9l4.8-4.4L23.2,9.2z  M20.5,78.4V18.9L53,48.7L20.5,78.4z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M53.6,11.9c0,2.4,2,4.4,4.4,4.4h20.6v64.6H57.9c-2.4,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4h29.4V7.6H57.9 C55.5,7.5,53.6,9.5,53.6,11.9z"
}));

var SvgIconTutorial = function SvgIconTutorial(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconTutorial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon-Tutorial.6dee5f85.svg";
export { ForwardRef as ReactComponent };